import React, { Fragment, useEffect } from 'react';
import { Button, Card, Col, Form, Icon, InputNumber, message, Result, Row, Select, Table, Tag } from 'antd';
import { useHistory } from 'react-router-dom';
import * as CommonService from '../../../services/CommonService';
import { PURCHASE_ORDER } from '../../../services/endpoint';
import { currencyVND, dateToString, formatCurrency, parserNumber } from '../../../utils';
import InfoRow from '../../../components/common/info-row';
import SelectIMEI from './components/SelectIMEI';
import TextArea from 'antd/es/input/TextArea';
import { PAYMENT_METHOD } from '../../../utils/const';
import SelectInfinitePro from '../../../components/common/select-infinite-pro';

const { Option } = Select;

const RefundCreate = (props) => {

	const history = useHistory();

	const [selectedProduct, setSelectedProduct] = React.useState(null);
	const [ds, setDs] = React.useState([]);
	const [visible, setVisible] = React.useState(false);
	const [curPurchase, setCurPurchase] = React.useState(null);
	const [curProduct, setCurProduct] = React.useState(null);
	const [imeiList, setImeiList] = React.useState([]);
	const [purchaseId, setPurchaseId] = React.useState(null);
	const [selectValue, setSelectedValue] = React.useState(null);

	useEffect(() => {
		const id = new URLSearchParams(window.location.search).get('id');
		if (id) {
			setPurchaseId(id);
			getPurchaseDetailById(id, true);
		}
	}, []);

	const handleSubmit = (e) => {
		e.preventDefault();
		props.form.validateFields((err, values) => {
			if (!err) {
				const body = {
					...values,
					id: curPurchase.id,
					refundOrderProducts: ds.map(el => ({
						orderProductId: el.id,
						quantity: el.isNormal ? (el?.[el.id] || 0) : el.imeiListRefund?.length || 0,
						imei: el.isNormal ? null : el.imeiListRefund?.map(i => imeiList.find(a => a.imei === i)?.id)
					}))
				};
				const totalProductRefund = body.refundOrderProducts.reduce((sum, item) => sum + item.quantity, 0);
				if (totalProductRefund === 0) {
					message.error('Vui lòng chọn sản phẩm muốn hoàn trả!');
					return;
				}
				delete body.supplier;
				window.setLoading(true);
				CommonService.create(PURCHASE_ORDER + '/refund', body).then(res => {
					if (res.status === 200) {
						message.success('Tạo đơn hoàn trả thành công');
						history.push('/refund');
					}
				}).catch(err => message.error(err?.data?.message))
					.finally(() => window.setLoading(false));
			} else {
				const errors = props.form.getFieldError('supplier')?.join(',') || null;
				if (errors) {
					const element = document.getElementById('select-infinite');
					setTimeout(() => {
						element.classList.add('has-error');
					}, 50);
				}
				window.scrollTo({ top: 0, behavior: 'smooth' });
			}
		});
	};

	const handleSelect = async (value) => {
		setSelectedValue(value);
		if (value) {
			if (value.value === selectedProduct?.id || '') {
				message.error('Bạn đã chọn sản phẩm này rồi');
				return;
			}
			await getPurchaseDetailById(value.value);
		} else {
			setDs([]);
			setSelectedProduct(null);
		}
	};

	const getPurchaseDetailById = async (id, setDefaultField = false) => {
		try {
			window.setLoading(true);
			const response = await CommonService.findById(PURCHASE_ORDER, id);
			const data = response.data || {};
			setCurPurchase(data);
			const orderProductList = data.orderProductResponse?.filter(el => el.type === 'IMPORT').map(el => ({
				...el,
				imeiList: el.imeiList?.filter(i => i.status === 0),
				totalProduct: el.isNormal ? el.quantity : el.imeiList?.filter(i => i.status === 0)?.length || 0
			})) || [];
			const imeiAll = [];
			orderProductList.forEach(el => {
				if (!el.isNormal) {
					imeiAll.push(...el.imeiList);
				}
			});
			setImeiList(imeiAll);
			setDs(orderProductList);
			setSelectedProduct(data);
			if (setDefaultField) {
				const supplierName = data?.supplierShortResponse.name || 'N/A'
				setSelectedValue({
					value: data.id,
					label: `${data.code} - ${supplierName}`,
					data: data
				});
			}
			return data;
		} catch (error) {
			message.error(error?.data?.message);
		} finally {
			window.setLoading(false);

		}
	};

	const renderOptions = data => {
		const el = data.data;
		return <Row>
			<Col span={20}>
				<b>{el.code}</b>
			</Col>
			<Col span={4} style={{ textAlign: 'right' }}>
				Giá nhập: {currencyVND(el.price)}
			</Col>
			<Col span={20}>
				<i>Nhà cung cấp: {el.supplierName}</i>
			</Col>
			<Col span={4} style={{ textAlign: 'right' }}>
				Ngày tạo: {dateToString(el.createdDate)}
			</Col>
		</Row>;
	};

	const handleSelectImei = (imeiList) => {
		curProduct.imeiListRefund = imeiList;
		curProduct[curProduct.id] = imeiList.length;
		setDs([...ds]);
	};


	const columns = [
		{
			title: 'STT',
			dataIndex: 'index',
			key: 'index',
			width: 60,
			render: (text, record, index) => index + 1
		},
		{
			title: 'Mã sản phẩm',
			dataIndex: 'code',
			key: 'code',
			align: 'center',
			width: 130,
			render: (code, record) => <Fragment>
				<Row gutter={12} style={{ marginTop: 10 }}>
					<Col>
						<Button type="link" onClick={() => {
							window.open(`/product/${record.productId}`);
						}}>{code}</Button>
					</Col>
				</Row>
			</Fragment>
		},
		{
			title: 'Tên sản phẩm',
			dataIndex: 'productName',
			width: 200
		},
		{
			title: 'Phân Loại',
			dataIndex: 'isNormal',
			key: 'isNormal',
			align: 'center',
			width: 130,
			render: (isNormal) => {
				return isNormal ? <Tag style={{ width: '110px' }} color="magenta">Sản phẩm thường</Tag> :
					<Tag style={{ width: '110px' }} color="green">Serial/IMEI</Tag>;
			}
		},
		{
			title: 'Số lượng',
			width: 200,
			align: 'center',
			render: (text, record) => {
				return <Fragment>
					{record.isNormal ? <InputNumber defaultValue={0} min={0} value={record[record.id] || 0} onChange={value => {
						record[record.id] = value;
						setDs([...ds]);
					}} max={record.totalProduct} /> : record[record.id] || 0} / {record.totalProduct}
					{!record.isNormal && <Fragment><br />
						<Button type={'link'} onClick={() => {
							setVisible(true);
							setCurProduct(record);
						}}> <span style={{ fontSize: '12px' }}>Chọn IMEI để trả</span></Button></Fragment>}
				</Fragment>;
			}
		},
		{
			title: 'Giá hàng trả',
			width: 130,
			align: 'center',
			render: (text, record) => currencyVND(record.price - record.discount)
		},
		// {
		// 	title: 'Chiết khấu',
		// 	width: 100,
		// 	align: 'center',
		// 	render: (text, record) => currencyVND(record.discount)
		// },
		{
			title: 'Thành tiền',
			width: 200,
			align: 'center',
			render: (text, record) => currencyVND(((record[record.id] || 0) * record.price) - (record.discount > 0 ? record.discount * record[record.id] : 0))
		}
	];

	const renderFooter = () => {
		const totalRefund = ds.reduce((sum, item) => sum + (item.isNormal ? (item[item.id] || 0) : (item.imeiListRefund?.length || 0)), 0);
		let totalMoneyNormalProduct = 0;
		let totalMoneyImeiProduct = 0;
		ds.forEach(el => {
			if (el.isNormal) {
				totalMoneyNormalProduct += ((el[el.id] || 0) * el.price) - (el.discount || 0);
			} else {
				totalMoneyImeiProduct += (el.imeiListRefund?.length || 0) * (el.price || 0) - ((el.discount || 0) * (el.imeiListRefund?.length || 0));
			}
		});
		const total = totalMoneyNormalProduct + totalMoneyImeiProduct;
		return <Fragment>
			<InfoRow labelSpan={8} valueSpan={16} label={'Số lượng'} value={totalRefund} />
			<InfoRow labelSpan={8} valueSpan={16} label={'Tổng tiền'}
							 value={total > 0  ? currencyVND(total) : '---'} />
			{/*<InfoRow labelSpan={8} valueSpan={16} label={'Chiết khấu'} value={currencyVND(curPurchase.discount)} />*/}
			<InfoRow labelSpan={8} valueSpan={16} label={<b>Tổng giá trị hàng trả</b>}
							 value={<b
								 style={{ color: 'red' }}>{(totalRefund > 0) ? currencyVND(totalMoneyImeiProduct + totalMoneyNormalProduct) : '---'} </b>} />
		</Fragment>;
	};

	const refundAll = () => {
		ds.forEach(el => {
			if (el.isNormal) {
				el[el.id] = el.totalProduct;
			} else {
				el.imeiListRefund = el.imeiList.map(el => el.imei);
				el[el.id] = el.imeiList.length;
			}
		});
		setDs([...ds]);
	};

	const renderOptionPaymentMethod = () => {
		const paymentMethod = PAYMENT_METHOD;
		paymentMethod.COD = 'COD';
		return Object.keys(paymentMethod).map(el => <Option value={el}>{paymentMethod[el]}</Option>);
	};

	const getExpandedRowKeys = () => {
		return ds.filter(el => !el.isNormal).map(el => el.id);
	};

	const expandedRowRender = (record) => {
		const imeiList = record?.imeiListRefund;
		return <Fragment>
			<div style={{ marginLeft: '60px' }}>
				<div className={'mt-20 mb-20'}>
					<i>Danh sách IMEI đã chọn ({imeiList?.length || 0}): </i>{imeiList?.map((el) => <Tag color={'blue'} key={el}>
					{el}
				</Tag>)}
				</div>
			</div>
		</Fragment>;
	};

	return (
		<Fragment>
			<Form layout={'vertical'}>
				<Row gutter={12}>
					<Card title={'Chọn sản phẩm'}>
						<SelectInfinitePro endpoint={PURCHASE_ORDER}
															 isDisabled={!!purchaseId}
															 handleSelect={handleSelect}
															 placeholder={'Tìm theo tên, mã...'}
															 dataOption={el => ({
																 value: el.id,
																 label: `${el.code} - ${el.supplierName}`,
																 data: el
															 })}
															 customOption={renderOptions}
															 value={selectValue}
															 defaultValue={selectValue}
						/>
					</Card>

					{selectedProduct ? <><Card title={'Thông tin sản phẩm trả'} className={'mt-20'}>
						<p style={{ textAlign: 'right' }}><Button onClick={refundAll}>Trả toàn bộ sản phẩm</Button></p>
						<Table columns={columns}
									 dataSource={ds}
									 pagination={false}
									 rowKey={record => record.id}
									 expandedRowRender={expandedRowRender}
									 expandedRowKeys={getExpandedRowKeys()}
									 expandIconAsCell={false}
									 expandIcon={() => ''}
						/>
						<Col className={'mt-20'}>
							<Row>
								<Col span={8}>
									{renderFooter()}
								</Col>
								<Col span={16}>
									<Form.Item label={'Lý do trả hàng'}>
										{props.form.getFieldDecorator('reason', {})(
											<TextArea placeholder={'Nhập lý do trả hàng'} rows={3} />
										)}
									</Form.Item>
								</Col>
							</Row>
						</Col>
					</Card>
						{curPurchase.amountReceivedBack > 0 && <Card className={'mt-20'}
																												 title={<Fragment><Icon type="credit-card"
																																								theme="twoTone" /> Nhận tiền hoàn lại từ
																													 nhà cung cấp
																												 </Fragment>}>
							<Row gutter={12}>
								<Col span={12}>
									<Form.Item label={'Nhập số tiền nhận lại'}>
										{props.form.getFieldDecorator('amountReceivedBack', {})(
											<InputNumber placeholder="Nhập số tiền nhận lại"
																	 formatter={formatCurrency}
																	 parser={parserNumber}
																	 step={1000}
																	 min={0}
																	 max={curPurchase.amountReceivedBack}
																	 style={{ width: '100%' }} />)}
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item label={`Phương thức thanh toán`}>
										{props.form.getFieldDecorator(`paymentMethod`, {
											initialValue: 'CASH'
										})(<Select placeholder="Chọn phương thức thanh toán" style={{ width: '100%' }}>
											{renderOptionPaymentMethod()}
										</Select>)}
									</Form.Item>
								</Col>
							</Row>
							<Col>
								<p>Số tiền có thể nhận lại: <b
									style={{ color: '#0000ffa6' }}>{currencyVND(curPurchase.amountReceivedBack)}</b></p>
							</Col>
						</Card>}
					</> : <Card className={'mt-20'}>
						<Result
							className={'result-ima'}
							icon={<Icon type="inbox" />}
							subTitle="Vui lòng chọn sản phẩm"
						/>
					</Card>}
					<Col style={{ textAlign: 'right', marginTop: 10 }}>
						<Button style={{ marginRight: '5px' }} onClick={() => history.push('/purchase-order')}>Thoát</Button>
						<Button type={'primary'} onClick={handleSubmit}>Tạo đơn hoàn trả</Button>
					</Col>
					<SelectIMEI visible={visible} setVisible={setVisible} curProduct={curProduct}
											handleSelectImei={handleSelectImei} />
				</Row>
			</Form>
		</Fragment>
	);
};
export default Form.create({
	name: 'RefundCreate'
})(RefundCreate);
